import React from "react";
import Input from "Components/UI/Input";
import { useFormContext } from "react-hook-form";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";
import dayjs from "dayjs";
import InputWarningMessage from "Components/UI/InputWarningMessage";
const boolStatus = [
  { id: "1", label: "Yes", value: true },
  { id: "0", label: "No", value: false },
];

const IndemnityModal = ({
  mode = "I",
  onSubmit,
  show = false,
  handleClose,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    trigger,
    setValue,
  } = useFormContext();

  const handleModalSubmit = (e) => {
    e.stopPropagation();
  };

  const hikePercentageAmountCalculator = () => {
    const currentBaseSalary = watch("currentBaseSalary");
    const hikePercentage = watch("hikePercentage");
    const hikeAmount = (currentBaseSalary * hikePercentage) / 100;
    const newSalary = Number(currentBaseSalary) + Number(hikeAmount);
    setValue("hikeAmount", Number(hikeAmount).toFixed(2));
    setValue("newSalary", Number(newSalary).toFixed(2));
  };

  const hikeAmountPercentageCalculator = () => {
    const currentBaseSalary = watch("currentBaseSalary");
    const hikeAmount = watch("hikeAmount");
    const hikePercentage = (hikeAmount * 100) / currentBaseSalary;
    const newSalary = Number(currentBaseSalary) + Number(hikeAmount);
    setValue("hikePercentage", Number(hikePercentage).toFixed(2));
    setValue("newSalary", Number(newSalary).toFixed(2));
  };

  console.log(errors);
  return (
    <Modal show={show} onHide={handleClose} animation={true} centered size="lg">
      <Modal.Header
        className="modal-header border-0 custom-modal-header"
        style={{ justifyContent: "space-between" }}
      >
        <div className="page-title">
          <h4>{mode === "I" ? "Add Indemnity" : "Edit Indemnity"}</h4>
        </div>
        <button type="button" className="close" onClick={handleClose}>
          <span aria-hidden="true">×</span>
        </button>
      </Modal.Header>
      <Modal.Body>
        {/* <form onSubmit={handleSubmit(onSubmit)} className="needs-validation"> */}
        <form
          onSubmit={(e) => {
            handleModalSubmit(e);
            handleSubmit(onSubmit)(e);
          }}
          className="needs-validation"
        >
          <div className="form-row row">
            <div className="col-md-6 col-sg-12 mb-3">
              <Input
                name="vehicleNumber"
                type="text"
                label="Vehicle Number"
                labelClassName="form-label"
                placeholder="Vehicle Number"
                className={`form-control ${
                  errors.vehicleNumber ? "is-invalid" : ""
                }`}
                required={true}
                requiredMessage="Vehicle Number is required"
              />
            </div>

            <div className="col-md-6 col-sg-12 mb-3">
              <Input
                name="indemnityNumber"
                type="text"
                label="Indemnity Number"
                labelClassName="form-label"
                placeholder="Indemnity Number"
                className={`form-control ${
                  errors.indemnityNumber ? "is-invalid" : ""
                }`}
                required={true}
                requiredMessage="Indemnity Number is required"
              />
            </div>

            <div className="col-md-6 col-sg-12 mb-3">
              <Input
                name="indemnityDate"
                type="date"
                label="Indemnity Date"
                labelClassName="form-label"
                placeholder="Indemnity Date"
                className={`form-control ${
                  errors.indemnityDate ? "is-invalid" : ""
                }`}
                required={true}
                requiredMessage="Indemnity Date is required"
                dateFormat="YYYY-MM-DD"
                getPopupContainer={(trigger) => trigger.parentElement}
              />
            </div>

            <div className="col-md-6 col-sg-12 mb-3">
              <Input
                name="driverName"
                type="text"
                label="Driver Name"
                labelClassName="form-label"
                placeholder="Driver Name"
                className={`form-control ${
                  errors.driverName ? "is-invalid" : ""
                }`}
                required={true}
                requiredMessage="Driver Name is required"
              />
            </div>

            <div className="col-md-6 col-sg-12 mb-3">
              <Input
                name="driverNRICFin"
                type="text"
                label="Driver NRIC/FIN"
                labelClassName="form-label"
                placeholder="Driver NRIC/FIN"
                className={`form-control ${
                  errors.driverNRICFin ? "is-invalid" : ""
                }`}
                required={true}
                requiredMessage="Driver NRIC/FIN is required"
              />
            </div>

            <div className="col-md-6 col-sg-12 mb-3">
              <Input
                name="ltA_HDB"
                type="text"
                label="LTA / HDB"
                labelClassName="form-label"
                placeholder="LTA or HDB"
                className={`form-control ${errors.ltA_HDB ? "is-invalid" : ""}`}
                required={true}
                requiredMessage="LTA / HDB is required"
              />
            </div>

            <div className="col-md-6 col-sg-12 mb-3">
              <Input
                name="noticeNumber"
                type="text"
                label="Notice Number"
                labelClassName="form-label"
                placeholder="Notice Number"
                className={`form-control ${
                  errors.noticeNumber ? "is-invalid" : ""
                }`}
                required={true}
                requiredMessage="Notice Number is required"
              />
            </div>

            <div className="col-md-6 col-sg-12 mb-3">
              <Input
                name="vendor"
                type="text"
                label="Vendor"
                labelClassName="form-label"
                placeholder="Vendor"
                className={`form-control ${errors.vendor ? "is-invalid" : ""}`}
                required={true}
                requiredMessage="Vendor is required"
              />
            </div>

            <div className="col-md-6 col-sg-12 mb-3">
              <Input
                name="invoiceNumber"
                type="text"
                label="Invoice Number"
                labelClassName="form-label"
                placeholder="Invoice Number"
                className={`form-control ${
                  errors.invoiceNumber ? "is-invalid" : ""
                }`}
                required={true}
                requiredMessage="Invoice Number is required"
              />
            </div>

            <div className="col-md-6 col-sg-12 mb-3">
              <Input
                name="amount"
                type="number"
                label="Amount"
                labelClassName="form-label"
                placeholder="Amount"
                className={`form-control ${errors.amount ? "is-invalid" : ""}`}
                required={true}
                requiredMessage="Amount is required"
              />
            </div>

            <div className="col-md-6 col-sg-12 mb-3">
              <Input
                name="incidentAddress"
                type="text"
                label="Incident Address"
                labelClassName="form-label"
                placeholder="Incident Address"
                className={`form-control ${
                  errors.incidentAddress ? "is-invalid" : ""
                }`}
                required={true}
                requiredMessage="Incident Address is required"
              />
            </div>

            <div className="col-md-6 col-sg-12 mb-3">
              <Input
                name="issuedBy"
                type="text"
                label="Issued By"
                labelClassName="form-label"
                placeholder="Issued By"
                className={`form-control ${
                  errors.issuedBy ? "is-invalid" : ""
                }`}
                required={true}
                requiredMessage="Issued By is required"
              />
            </div>

            <div className="col-md-6 col-sg-12 mb-3">
              <Input
                name="designation"
                type="text"
                label="Designation"
                labelClassName="form-label"
                placeholder="Designation"
                className={`form-control ${
                  errors.designation ? "is-invalid" : ""
                }`}
                required={true}
                requiredMessage="Designation is required"
              />
            </div>

            <div className="col-md-6 col-sg-12 mb-3">
              <Input
                name="issuerNRIC"
                type="text"
                label="Issuer NRIC"
                labelClassName="form-label"
                placeholder="Issuer NRIC"
                className={`form-control ${
                  errors.issuerNRIC ? "is-invalid" : ""
                }`}
                required={true}
                requiredMessage="Issuer NRIC is required"
              />
            </div>

            <div className="col-md-6 col-sg-12 mb-3">
              <Input
                name="debitStaffAmount"
                type="number"
                label="Debit Staff Amount"
                labelClassName="form-label"
                placeholder="Debit Staff Amount"
                className={`form-control ${
                  errors.debitStaffAmount ? "is-invalid" : ""
                }`}
                required={true}
                requiredMessage="Debit Staff Amount is required"
              />
            </div>

            <div className="col-md-6 col-sg-12 mb-3">
              <Input
                name="writeOffAmount"
                type="number"
                label="Write-off Amount"
                labelClassName="form-label"
                placeholder="Write-off Amount"
                className={`form-control ${
                  errors.writeOffAmount ? "is-invalid" : ""
                }`}
                required={true}
                requiredMessage="Write-off Amount is required"
              />
            </div>

            <div className="col-md-6 col-sg-12 mb-3">
              <Input
                name="description"
                type="text"
                label="Description"
                labelClassName="form-label"
                placeholder="Penalty or Description"
                className={`form-control ${
                  errors.description ? "is-invalid" : ""
                }`}
                required={true}
                requiredMessage="Description is required"
              />
            </div>

            <div className="col-md-6 col-sg-12 mb-3">
              <Input
                name="isActive"
                type="commonSelect"
                placeholder="Select Status"
                label="Status"
                labelClassName="form-label"
                optionData={boolStatus}
                className={`form-control select ${
                  errors.isActive ? "is-invalid" : ""
                }`}
                required={true}
                requiredMessage="Status is required"
                onChange={(selectedOption) => {
                  setValue("isActive", selectedOption?.value);
                  trigger("isActive");
                }}
                defaultValue={watch("isActive")}
              />
            </div>
          </div>
          <div className="text-end mt-3">
            <button type="submit" className="btn btn-primary">
              {mode === "I" ? "Add" : "Update"}
            </button>
          </div>
          <InputWarningMessage
            message="*All mandatory fields to be entered to Save the record."
            type="danger"
          />
        </form>
      </Modal.Body>
    </Modal>
  );
};

IndemnityModal.propTypes = {
  mode: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default IndemnityModal;
